import { useTheme } from '@/contexts/ThemeContext';

const differentials = [
  {
    icon: 'ri-settings-3-line',
    title: 'Projetos 100% Sob Medida',
    description: 'Nenhum sistema genérico. Cada projeto é desenvolvido do zero, mapeando seus processos e entregando uma solução que se adapta perfeitamente ao seu negócio.',
  },
  {
    icon: 'ri-stack-line',
    title: 'Arquitetura Moderna',
    description: 'Utilizamos tecnologias de ponta: React, Node.js, PostgreSQL, microsserviços e cloud-native. Sistemas preparados para o presente e para o futuro.',
  },
  {
    icon: 'ri-speed-line',
    title: 'Alta Performance',
    description: 'Sistemas otimizados para resposta rápida, baixa latência e alta disponibilidade. Infraestrutura escalável que cresce junto com o seu negócio.',
  },
  {
    icon: 'ri-layout-masonry-line',
    title: 'Interface Intuitiva',
    description: 'UX/UI projetada para o usuário final. Interfaces limpas, fluxos simplificados e curva de aprendizado mínima, aumentando a adoção e produtividade.',
  },
  {
    icon: 'ri-expand-diagonal-line',
    title: 'Escalabilidade',
    description: 'Arquitetura preparada para crescer. Seja 10 ou 10.000 usuários simultâneos, o sistema mantém performance e estabilidade sem necessidade de reescrita.',
  },
  {
    icon: 'ri-plug-line',
    title: 'Integrações com APIs',
    description: 'Conectamos seu sistema a qualquer plataforma: ERPs de mercado, gateways de pagamento, NFe, eSocial, SEFAZ, CRMs, marketplaces e muito mais.',
  },
  {
    icon: 'ri-shield-keyhole-line',
    title: 'Segurança Corporativa',
    description: 'Controle de acesso por perfil, criptografia de dados, logs de auditoria, backups automáticos e conformidade com LGPD. Seus dados sempre protegidos.',
  },
  {
    icon: 'ri-eye-line',
    title: 'Visão Estratégica',
    description: 'Não somos apenas desenvolvedores. Entendemos o seu negócio e sugerimos melhorias de processo, automações e indicadores que geram valor real.',
  },
];

export default function Differentials() {
  const { isDark } = useTheme();

  return (
    <section
      id="diferenciais"
      className={`py-28 relative overflow-hidden transition-colors duration-500 ${isDark ? 'bg-[#080d1a]' : 'bg-white'}`}
    >
      {/* Background accent */}
      <div className={`absolute top-0 left-1/2 -translate-x-1/2 w-full h-px bg-gradient-to-r from-transparent to-transparent ${
        isDark ? 'via-cyan-500/30' : 'via-cyan-400/30'
      }`}></div>
      <div className={`absolute top-1/2 left-0 w-72 h-72 rounded-full blur-3xl pointer-events-none ${isDark ? 'bg-cyan-500/5' : 'bg-cyan-400/8'}`}></div>
      <div className={`absolute bottom-0 right-0 w-96 h-96 rounded-full blur-3xl pointer-events-none ${isDark ? 'bg-blue-600/5' : 'bg-cyan-300/8'}`}></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="grid lg:grid-cols-2 gap-12 items-end mb-16">
          <div className="flex flex-col gap-4">
            <div className={`inline-flex items-center gap-2 px-4 py-1.5 rounded-full border w-fit ${
              isDark ? 'border-cyan-500/30 bg-cyan-500/10' : 'border-cyan-400/40 bg-cyan-50'
            }`}>
              <i className="ri-award-line text-cyan-500 text-sm"></i>
              <span className="text-cyan-600 text-xs font-semibold tracking-widest uppercase">Por que a Granato</span>
            </div>
            <h2 className={`text-3xl lg:text-5xl font-bold leading-tight ${isDark ? 'text-white' : 'text-slate-900'}`}>
              Diferenciais que{' '}
              <span className="bg-gradient-to-r from-cyan-500 to-cyan-400 bg-clip-text text-transparent">
                fazem a diferença
              </span>
            </h2>
          </div>
          <p className={`text-lg leading-relaxed ${isDark ? 'text-slate-400' : 'text-slate-600'}`}>
            Combinamos expertise técnica com visão de negócio para entregar sistemas que realmente transformam a operação das empresas. Não entregamos código — entregamos resultados.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {differentials.map((diff, i) => (
            <div
              key={diff.title}
              className={`group relative rounded-2xl p-6 border transition-all duration-300 cursor-pointer ${
                isDark
                  ? 'border-white/8 bg-[#0d1526] hover:border-cyan-500/25 hover:bg-[#0f1a30]'
                  : 'border-slate-200 bg-slate-50 hover:border-cyan-400/40 hover:bg-white'
              }`}
            >
              <div className="flex flex-col gap-4">
                <div className={`w-11 h-11 flex items-center justify-center rounded-xl border transition-colors duration-300 ${
                  isDark
                    ? 'bg-cyan-500/10 border-cyan-500/20 group-hover:bg-cyan-500/20'
                    : 'bg-cyan-50 border-cyan-200 group-hover:bg-cyan-100'
                }`}>
                  <i className={`${diff.icon} text-cyan-500 text-xl`}></i>
                </div>
                <div>
                  <h3 className={`text-base font-bold mb-2 leading-snug ${isDark ? 'text-white' : 'text-slate-900'}`}>{diff.title}</h3>
                  <p className={`text-sm leading-relaxed ${isDark ? 'text-slate-500' : 'text-slate-600'}`}>{diff.description}</p>
                </div>
              </div>
              <div className={`absolute top-4 right-4 text-xs font-mono ${isDark ? 'text-slate-700' : 'text-slate-300'}`}>
                0{i + 1}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
